<template>
  <div class="has_market_price">
    <Header />
    <MarketData />
    <Footer />
    <market-price />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MarketData from "@/components/MarketData";
import MarketPrice from "@/components/MarketPrice";

export default {
  components: {
    Header,
    Footer,
    MarketData,
    MarketPrice
  }
};
</script>
